import React from 'react'
import { useSelector } from 'react-redux'
import { getCurPatientData } from 'stores/Account/Select'
import Logo from 'components/Logo'
import { Space } from 'antd'
import _ from 'lodash'
import styles from './styles'
import { localization } from './localization'
import withLocalization from '@web/helpers/localizationUtils'

const PrintHeader = props => {
  const { t } = props
  const title = _.get(props, 'title', 'medication')
  const showHeader = _.get(props, 'showHeader', false)
  const curPatientData = useSelector(getCurPatientData)
  return (
      <div className="print-page-header">
        <Logo style={styles.printPageLogo} keepLightTheme/>
          <div style={styles.headerText(showHeader)}>
            <Space style={styles.space}><div><strong>{`${t('patientName')} `}</strong>{_.get(curPatientData, 'firstname')} {_.get(curPatientData, 'lastname')}</div></Space>
            <Space style={styles.space}>
              <div style={styles.subHeaderText}><strong>{`${t('dob')} `}</strong>{_.get(curPatientData, 'birthDate', '-').replaceAll('-', '/')}</div>
            </Space>
          </div>
        <div style={styles.headerTitle(showHeader)}><strong>{t(title)}</strong></div>
      </div>
  )
}

export default withLocalization(PrintHeader, localization)

